import React, { Component } from 'react';
import { Modal, Radio, message } from 'antd';
import FloorPriceModal from './FloorPriceModal';
import API_URL from "../../../common/url";
import $ from '../../../common/AjaxRequest';

const RadioGroup = Radio.Group;

class FloorPrice extends Component {
    state = {
        record: {},
        visible: false,
        loading: false,
        basePriceStatus: '',
        type: '',
    }

    show = (record = {}, type) => {
        this.setState({
            record,
            visible: true,
            type,
        });
    }

    //获取项目基本信息数据
    loadData = (evaluateRecordId) => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateServeCustomer,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const {
                    data: {
                        evaluateRecordView,//项目基本信息
                        evaluateRecordCustomer,//客户项目参数
                    }
                } = res;
                this.setState(
                    {
                        params: {
                            evaluateRecordId,
                            ...evaluateRecordView,
                            ...evaluateRecordCustomer,
                        },
                    }
                );
            },
        }
        $.sendRequest(options);
    }


    hide = () => {
        this.setState({
            record: {},
            visible: false,
            basePriceStatus: '',
        });
    }

    handleChange = value => {
        this.setState({ basePriceStatus: value })
    }

    sumbit = () => {
        const { basePriceStatus, record, type } = this.state;
        const { evaluateRecordId } = record;
        if (!basePriceStatus) {
            return message.warning('请选择建议底价方式')
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.insertBasePriceStatus,
            data: {
                evaluateRecordId,
                basePriceStatus,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.FloorPriceModalRef.show(record, type, basePriceStatus, res.basePrice);
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, basePriceStatus, loading } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title="建议底价"
                visible={visible}
                onOk={this.sumbit}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width={400}
                bodyStyle={{ maxHeight: 600 }}
            >
                <div style={{ padding: '15px 30px' }}>
                    <div style={{ padding: '10px' }}>{asterisk}请选择建议底价方式：</div>
                    <RadioGroup 
                        style={{ padding: '10px 30px' }}
                        value={basePriceStatus}
                        onChange={e => this.handleChange(e.target.value)} 
                    >
                        <Radio value='VISIT' style={{ marginRight: 50 }}>访视制</Radio>
                        <Radio value='FTE'>一口价（FTE制）</Radio>
                    </RadioGroup>
                </div>
                <FloorPriceModal 
                    ref={el => this.FloorPriceModalRef = el} 
                    hide={this.hide} 
                    loadData={this.props.loadData} 
                />
            </Modal>
        );
    }
}

export default FloorPrice;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/FloorPrice.js